import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { UndoRedoAnnotationsShortcuts } from '../components/UndoRedoAnnotationsShortcuts';
import { IUndoRedoHistory } from '../undoRedoHistory.service';

interface IProps {
  undo: boolean;
}

export interface IUndoRedoAnnotationsShortcutsProps {
  undo: boolean;
  enabled: boolean;
  onClick: () => void;
}

export const UndoRedoAnnotationsShortcutsContainer = observer((props: IProps): ReactElement => {
  const undoRedoHistory = useInjection(IUndoRedoHistory.$);

  const handleClick = (): void => {
    if (props.undo) {
      undoRedoHistory.undo();
    } else {
      undoRedoHistory.redo();
    }
  };

  return (
    <UndoRedoAnnotationsShortcuts
      undo={props.undo}
      enabled={props.undo ? undoRedoHistory.canUndo : undoRedoHistory.canRedo}
      onClick={handleClick}
    />
  );
});
